var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDescarregamentoIndevido(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.27,
    height: 18.657,
    viewBox: "0 0 20.27 18.657",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_870",
    "data-name": "Caminho 870",
    d: "M111.363,382.2l-5.483,5.482L100.4,382.2a10.135,10.135,0,1,0,10.965,0Zm.219,13.681-2.476,2.476-3.225-3.225-3.225,3.225-2.476-2.476,3.225-3.225-3.225-3.225,2.476-2.476,3.225,3.225,3.225-3.225,2.476,2.476-3.225,3.225Z",
    transform: "translate(-95.746 -382.199)",
    fill: "red"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDescarregamentoIndevido);
export default __webpack_public_path__ + "static/media/descarregamento-indevido.cfb0d0e2789211052d24561b9f5c4563.svg";
export { ForwardRef as ReactComponent };